// Database Collection Names
export const COLLECTIONS = {
  USERS: 'Users',
  CLIENT_ORG: 'Client_Organization',
};

// Shared Form Options
export const GENDER_OPTIONS = [
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
  { value: 'Non-binary', label: 'Non-binary' },
  { value: 'Other', label: 'Other' },
  { value: 'Prefer not to say', label: 'Prefer not to say' },
];

export const VETERAN_OPTIONS = [
  { value: 'Veteran', label: 'Veteran' },
  { value: 'Active Service', label: 'Active Service' },
  { value: 'Military Spouse', label: 'Military Spouse' },
  { value: 'N/A', label: 'N/A' },
];

export const DISABILITY_OPTIONS = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
];

// Country/Currency options from CreateNewUserModal here too
export const COUNTRY_OPTIONS = [
  { id: 'US', label: '🇺🇸 +1', code: '+1' },
  { id: 'IN', label: '🇮🇳 +91', code: '+91' },
  { id: 'GB', label: '🇬🇧 +44', code: '+44' },
  // ... add the rest from your other file
];

export const BUSINESS_TYPE_OPTIONS = [
  { value: 'Non-profit', label: 'Non-profit' },
  { value: 'For-profit', label: 'For-profit' },
  { value: 'B Corp', label: 'B Corp' },
  { value: 'Other', label: 'Other' },
];

export const CURRENCY_OPTIONS = [
  { value: 'USD', label: '$ (USD)' },
  { value: 'INR', label: '₹ (INR)' },
  { value: 'EUR', label: '€ (EUR)' },
  { value: 'GBP', label: '£ (GBP)' },
  { value: 'AED', label: 'د.إ (AED)' },
];


export const modalStyle = {
  position: 'absolute', top: '50%', left: '50%',
  transform: 'translate(-50%, -50%)', width: 600,
  bgcolor: "#11002e", border: '2px solid #5406D2', boxShadow: 24, p: 4,
  borderRadius: '8px'
};

export const inputStyle = {
  bgcolor: "black", borderRadius: '4px',
  '& .MuiOutlinedInput-root': {
    '& fieldset': { borderColor: 'white' },
    '&:hover fieldset': { borderColor: 'gray' },
  },
  input: { color: 'white' },
  label: { color: 'white' },
  '& .MuiSelect-select': { color: 'white' },
  '& .MuiSvgIcon-root': { color: 'white' },
};

export const DROPDOWN_FIELDS = [
  {
    name: 'gender',
    label: 'Gender',
    options: GENDER_OPTIONS,
  },
  {
    name: 'businessType',
    label: 'Business type',
    options: BUSINESS_TYPE_OPTIONS,
  },
  {
    name: 'veteranStatus',
    label: 'Veteran Status',
    options: VETERAN_OPTIONS,
  },
  {
    name: 'disabled',
    label: 'Disability Status',
    options: DISABILITY_OPTIONS,
  },
];


export const INITIAL_CLIENT_STATE = {
  name: "",
  organizationName: "",
  email: "",
  phone: "",
  website: "",
  companyRevenue: "",
  employeeCount: "",
  foundedYear: "",
  proposals: {},
  gender: '',
  businessType: '',
  veteranStatus: '',
  disabled: '',
};


export const API_ENDPOINTS = {
  ADD_COLLABORATOR: '/add-collaborator',
  EDIT_COLLABORATOR: '/edit-collaborator',
};

// Reusable Style Constants
export const MODAL_STYLES = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: "#11002e",
  border: '2px solid #5406D2',
  boxShadow: 24,
  p: 4,
  borderRadius: '8px'
};

export const INPUT_STYLES = {
  bgcolor: "black",
  borderRadius: '4px',
  '& .MuiOutlinedInput-root': {
    '& fieldset': { borderColor: 'white' },
    '&:hover fieldset': { borderColor: 'gray' },
    '&.Mui-focused fieldset': { borderColor: 'blue' },
  },
  input: { color: 'white' },
  label: { color: 'white' },
  '& .MuiSelect-select': { color: 'white' },
  '& .MuiSvgIcon-root': { color: 'white' },
};

export const COUNTRY_SELECTOR_STYLES = {
  color: 'white',
  '.MuiSvgIcon-root': { color: 'white' },
  marginRight: 1
};
